import type { Product } from '../../../../api/products';

export const WIZARD_SERVICES = ['Flood', 'Title', 'Valuation'] as const;

export interface ProviderNode {
  provider: string;
  products: { urn: string; name: string }[];
}

export interface ProductTypeNode {
  productType: string;
  providers: ProviderNode[];
}

export interface ServiceNode {
  service: string;
  productTypes: ProductTypeNode[];
}

export function buildProductTree(products: Product[]): ServiceNode[] {
  return WIZARD_SERVICES.map((service) => {
    const ofService = products.filter((p) => p.serviceType === service);

    const byType = new Map<string, Map<string, { urn: string; name: string }[]>>();
    for (const product of ofService) {
      const providers = byType.get(product.productType) ?? new Map();
      byType.set(product.productType, providers);
      for (const vp of product.vendorProducts ?? []) {
        const leaves = providers.get(vp.vendorName) ?? [];
        providers.set(vp.vendorName, leaves);
        // The vendor product's own commercial name, like the MeridianLink UI shows it — the
        // parent's name collapses when one vendor offers several variants of the same product
        // (Cotality alone has three AVMs).
        leaves.push({ urn: vp.urn, name: vp.vendorProductName || product.productName });
      }
    }

    return {
      service,
      productTypes: [...byType.entries()].map(([productType, providers]) => ({
        productType,
        providers: [...providers.entries()].map(([provider, leaves]) => ({ provider, products: leaves })),
      })),
    };
  });
}
